/* unplugin-vue-components disabled */import script from "./SampleList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SampleList.vue?vue&type=script&lang=ts&setup=true"

import "./SampleList.vue?vue&type=style&index=0&id=bc7a3324&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc7a3324"]])

export default __exports__